import { useAtomValue } from "@effect/atom-react";
import { type EnvironmentId, isManagedByAfar } from "@afar-research/contracts";

import { useEnvironmentSettingsScope } from "../state/environmentSettingsScope";
import { serverEnvironment } from "../state/server";

/** Whether the Environment is a Cloud Workspace, whose Agent Providers AFAR manages. */
export function useEnvironmentManagedByAfar(environmentId: EnvironmentId | null): boolean {
  return isManagedByAfar(useAtomValue(serverEnvironment.configValueAtom(environmentId)));
}

/** Whether the Environment the settings are scoped to is a Cloud Workspace. */
export function useSettingsScopeManagedByAfar(): boolean {
  return useEnvironmentManagedByAfar(useEnvironmentSettingsScope()?.environmentId ?? null);
}
